exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".B4qVt7jUQ2yGcnRUa98bA figure{margin:0}\n", ""]);

// Exports
exports.locals = {
	"GuidePageViewer": "B4qVt7jUQ2yGcnRUa98bA"
};